import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: './pages/login/login.module#LoginPageModule' },
  { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardPageModule' },
  { path: 'dashboard-depot', loadChildren: './pages/dashboard-depot/dashboard-depot.module#DashboardDepotPageModule' },
  { path: 'login-repairer', loadChildren: './pages/login-repairer/login-repairer.module#LoginRepairerPageModule' },
  { path: 'restricted', loadChildren: './pages/restricted/restricted.module#RestrictedPageModule' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
